import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { SchoolServices } from '../../services';
import { ClassroomsCreateStudentsSelectPage } from '../classrooms-create-students-select/classrooms-create-students-select';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the MenuCreateDishSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-classrooms-create-teachers-select',
  templateUrl: 'classrooms-create-teachers-select.html',
})
export class ClassroomsCreateTeachersSelectPage {

  classroom_name: string = '';
  classroom: any;
  update_state: boolean = false;
  next_page: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public toastCtrl: ToastController,
    public schoolServices: SchoolServices,
    public translate: TranslateService) {

    this.update_state = this.navParams.get('update_state');
    this.schoolServices.classroom_update_state = this.update_state;
    if (this.update_state) {
      this.classroom = this.navParams.get('classroom');
      this.classroom_name = this.classroom.name;
      this.getTeachers();
      this.getStudents();
    }


  }

  onBack() {
    this.navCtrl.pop();
  }

  ionViewDidLeave() {
    if (this.update_state && !this.next_page) {
      this.schoolServices.classroom_teachers_array_tmp = Array(); //Limpiamos el array
      this.schoolServices.classroom_students_array_tmp = Array(); //Limpiamos el array
    }
  }

  async getTeachers() {
    for (let teacher of this.globals.objectToArray(this.classroom.teachers_list)) {
      var _array = Array();
      var _teacher = await this.schoolServices.getTeacher(teacher.uid_teacher);

      _array.push(_teacher.UID); //UID
      _array.push(_teacher.name);
      _array.push(_teacher.email);
      _array.push(_teacher.user_uid);

      this.schoolServices.classroom_teachers_array_tmp.push(_array);
    }
  }

  async getStudents() {
    for (let student of this.globals.objectToArray(this.classroom.students_list)) {
      var _array = Array();

      _array.push(student.uid_restaurant); //UID
      _array.push(student.name);
      _array.push(student.email);

      this.schoolServices.classroom_students_array_tmp.push(_array);

    }
  }

  async openAddStudents() {
    this.next_page = true;

    if (this.schoolServices.classroom_teachers_array_tmp.length == 0) {
      var toast = this.toastCtrl.create({
        message: this.translate.instant('instant-intoduce-un-profesor'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    } else {

      //Preparamos el objecto para insertarlo
      var _obj = {};
      for (var i = 0; this.schoolServices.classroom_teachers_array_tmp.length > i; i++) {

        _obj[i] = {
          uid_teacher: this.schoolServices.classroom_teachers_array_tmp[i][0],
          name: this.schoolServices.classroom_teachers_array_tmp[i][1],
          email: this.schoolServices.classroom_teachers_array_tmp[i][2],

        };
      }

      //no limpiamos porque necesitamos los profesores para añadirles los restaurantes en su usuario

      if (this.update_state) {
        this.schoolServices.afs.collection('classrooms').doc(this.classroom.UID).update({
          'name': this.classroom_name,
          'teachers_list': _obj,
          'updated_at': new Date(),
        }).then(() => {

          this.classroom.name = this.classroom_name;
          this.classroom.teachers_list = _obj;

          this.navCtrl.push(ClassroomsCreateStudentsSelectPage, {
            update_state: this.update_state,
            classroom_uid: this.classroom.UID,
            classroom: this.classroom,
          });
        });
      } else {

        //insert fb classrom
        await this.schoolServices.afs.collection('classrooms').add({
          'name': this.classroom_name,
          'school_uid': this.globals.school_uid,
          'teachers_list': _obj,
          'created_at': new Date(),
          'updated_at': new Date(),
        }).then(doc => {
          //nav push
          this.navCtrl.push(ClassroomsCreateStudentsSelectPage, {
            update_state: false,
            classroom_uid: doc.id,
          });
        });

      }
    }

  }


}



// WEBPACK FOOTER //
// ./src/pages/schools/classrooms-create/classrooms-create-teachers-select/classrooms-create-teachers-select.ts